export default __webpack_public_path__ + "static/media/weight.62cf9858.jpg";